import { useActionHistory } from "@/hooks/useActionHistory";
import { useApiMutation } from "@/hooks/useApiMutation";
import axiosInstance from "@/lib/axios";
import { clearMonitoringUser } from "@/lib/monitoring/userTracking";
import { clearUser as clearTrackingUser } from "@/lib/tracking";
import { isAuthenticatedAtom } from "@/store/authAtoms";
import { appStore } from "@/store/jotaiStore";
import { useQueryClient } from "@tanstack/react-query";
import { useRouter } from "@tanstack/react-router";
import { AUTH_MUTATION_KEYS } from "../types/auth";
import { clearTokensFromStorage } from "../utils/tokenStorage";

export const useLogout = () => {
  const queryClient = useQueryClient();
  const { navigate } = useRouter();
  const { clearActionHistory } = useActionHistory();
  return useApiMutation<void, void>({
    mutationOptions: {
      mutationKey: AUTH_MUTATION_KEYS.LOGOUT,
      mutationFn: () => axiosInstance.post("/auth/logout"),
      onSettled: () => {
        clearTokensFromStorage();
        clearMonitoringUser();
        clearTrackingUser();
        clearActionHistory();
        appStore.set(isAuthenticatedAtom, false);
        queryClient.clear();
        navigate({ to: "/login" });
      },
    },
  });
};
